<template>
	<div class="modal" :class="{ 'modal--dark': darkTheme }" @click="close">
		<div class="modal-holder" @click.stop>
			<span class="modal-title">
				Tips Not Accepted
			</span>
			<p>
				This business is not set up to accept tips
			</p>
			<dashed-line
				class="separator"
				:light-theme="darkTheme"
				:opacity="darkTheme && '0.2'"
			/>
			<p>
				Speak to staff if you have any questions
			</p>
			<div class="modal-buttons">
				<span class="button single-button" @click="close">
					Ok
				</span>
			</div>
		</div>
	</div>
</template>

<script>
import DashedLine from '@/components/DashedLine'

export default {
	name: 'NoTipsModal',
	components: {
		DashedLine
	},
	props: {
		darkTheme: {
			type: Boolean,
			default: false
		}
	},
	methods: {
		close() {
			this.$emit('close')
		}
	}
}
</script>
<style lang="scss" scoped>
.separator {
	margin: 0 5px 15px;
}
</style>
